<template>
    <div class="mb-8">
        <div class="relative">
            <span class="inline-block w-full rounded-md shadow-sm">
                <button
                    @click="open = !open"
                    type="button"
                    aria-haspopup="listbox"
                    aria-expanded="true"
                    aria-labelledby="listbox-label"
                    class="cursor-default relative w-full rounded-md border border-gray-300 bg-white pl-3 pr-10 py-2 text-left focus:outline-none focus:ring-blue-200 focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                >
                    <div class="flex items-center space-x-3">
                        <span
                            class="flex-shrink-0 h-6 w-6 rounded-full"
                            v-html="selected.language.flag"
                        ></span>
                        <span class="block truncate">
                            {{ selected.domain }}
                        </span>
                    </div>
                    <span
                        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    >
                        <svg
                            class="h-5 w-5 text-gray-400"
                            viewBox="0 0 20 20"
                            fill="none"
                            stroke="currentColor"
                        >
                            <path
                                d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </span>
                </button>
            </span>

            <!-- Select.vue popover, show/hide based on select state. -->
            <div
                v-if="open"
                class="absolute mt-1 w-full rounded-md bg-white shadow-lg"
            >
                <ul
                    tabindex="-1"
                    role="listbox"
                    aria-labelledby="listbox-label"
                    aria-activedescendant="listbox-item-3"
                    class="max-h-56 rounded-md py-1 text-base leading-6 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                >
                    <li
                        @click="() => setSite(site)"
                        v-for="site in sites"
                        :key="`site-${site.id}`"
                        :id="`listbox-item-${site.id}`"
                        role="option"
                        class="group"
                    >
                        <div
                            class="group-hover:text-white group-hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9"
                        >
                            <div class="flex items-center space-x-3">
                                <span
                                    class="flex-shrink-0 h-6 w-6 rounded-full"
                                    v-html="site.language.flag"
                                ></span>
                                <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                                <span
                                    :class="[
                                        'block truncate',
                                        selected.id === site.id
                                            ? 'font-semibold'
                                            : 'font-normal',
                                    ]"
                                >
                                    {{ site.domain }}
                                </span>
                            </div>
                            <span
                                v-if="selected.id === site.id"
                                class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-hover:text-white"
                            >
                                <svg
                                    class="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SiteSwitcher",
    props: {
        sites: Array,
        current: Number,
    },
    data() {
        return {
            currentId: this.current,
            open: false,
        };
    },
    methods: {
        async setSite(site) {
            // const { data } = await axios.post(this.route('site.switch', {site: site.id}))
            //     .catch(error => console.error(error || error))
            // if(data.success) this.redirect('home')
            this.currentId = site.id;
            this.open = false;
        },
    },
    computed: {
        selected() {
            const sites = this.sites.filter((cluster) => {
                return cluster.id === this.currentId;
            });
            if (sites.length) return sites[0];
            else return this.sites[0];
        },
    },
};
</script>
